import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAiLib = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_14826_33233",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 20,
			height: 20,
			children: /* @__PURE__ */ _jsx("rect", {
				width: 20,
				height: 20,
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_14826_33233)",
			children: /* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M17.1074 5.46875C17.2315 5.4688 17.3542 5.49472 17.4678 5.54492C17.5814 5.59517 17.683 5.66883 17.7666 5.76074C17.8502 5.85266 17.9138 5.96122 17.9531 6.0791C17.9923 6.19688 18.0068 6.32174 17.9951 6.44531H18V17.0996C18.001 17.2169 17.9789 17.3338 17.9346 17.4424C17.8901 17.5511 17.8242 17.6504 17.7412 17.7334C17.6582 17.8164 17.5588 17.8823 17.4502 17.9268C17.3417 17.971 17.2255 17.9932 17.1084 17.9922H6.4453C6.32172 18.0039 6.19686 17.9894 6.07908 17.9502C5.96121 17.9109 5.85265 17.8473 5.76073 17.7637C5.66882 17.6801 5.59516 17.5785 5.5449 17.4648C5.49471 17.3514 5.4688 17.2286 5.46873 17.1045C5.46873 16.9802 5.49465 16.8568 5.5449 16.7432C5.59516 16.6296 5.66882 16.5279 5.76073 16.4443C5.85264 16.3607 5.96121 16.2971 6.07908 16.2578C6.19686 16.2186 6.32172 16.2041 6.4453 16.2158H16.2187V6.44531C16.207 6.32176 16.2216 6.19686 16.2607 6.0791C16.3 5.96126 16.3637 5.85265 16.4472 5.76074C16.5308 5.66887 16.6325 5.59518 16.7461 5.54492C16.8597 5.49467 16.9832 5.46875 17.1074 5.46875ZM13.0996 2C13.4531 1.99999 13.7931 2.13953 14.0439 2.38867C14.2948 2.63784 14.4371 2.97652 14.4394 3.33008V13.0996C14.44 13.2757 14.4049 13.4504 14.3379 13.6133C14.2708 13.7762 14.1722 13.925 14.0478 14.0498C13.9235 14.1744 13.7758 14.2734 13.6133 14.3408C13.4506 14.4083 13.2757 14.4434 13.0996 14.4434L13.1094 14.4453H3.33006C2.97548 14.4429 2.63604 14.3 2.3867 14.0479C2.13736 13.7957 1.99839 13.4542 1.99998 13.0996V3.33008C1.99998 2.97735 2.14022 2.63907 2.38963 2.38965C2.63905 2.14023 2.97732 2 3.33006 2H13.0996ZM6.45116 7.85156L4.29979 8.7002L6.45116 9.54883L7.29979 11.7002L8.14842 9.54883L10.2998 8.7002L8.14842 7.85156L7.29979 5.7002L6.45116 7.85156ZM10.376 5.77539L9.29979 6.2002L10.376 6.62402L10.7998 7.7002L11.2246 6.62402L12.2998 6.2002L11.2246 5.77539L10.7998 4.7002L10.376 5.77539Z",
				fill: "#363F5A"
			})
		})
	]
});
const ForwardRef = forwardRef(SvgAiLib);
export default ForwardRef;
